import { gql } from '@apollo/client';

export const postConfirmacionEntradas = gql`
mutation ConfirmacionEntradasRQ{
    confirmacionEntradasRQ(input: $input)  
        @rest(type: "ConfirmacionEntradasRS", path: "/api/gateway/formularios/sorteo-confirma",  method: "post"){
            caso
            titulo
        }
}
`